/* Prayasa: size the Devanagari watermarks to the largest they can be without
   being clipped on the left or right. Measures real glyph width with a canvas,
   then sets font size from the space actually available.

   Collection header watermark: auto-fitted on MOBILE ONLY (desktop size comes
   from the stylesheet). The two section words fill the container on desktop and
   take roughly 62% of it on mobile, which sits them in the open space above the
   eyebrow with a slight crop at the right edge. */
(function(){
  'use strict';

  var FONT_STACK = "'Tiro Devanagari Hindi','Fraunces',Georgia,serif";
  var MOBILE_SHARE = 0.62;
  var canvas = document.createElement('canvas');
  var ctx = canvas.getContext && canvas.getContext('2d');
  if(!ctx) return;

  function widthPerPx(text){
    ctx.font = '400 100px ' + FONT_STACK;
    var w = ctx.measureText(text).width;
    return w > 0 ? w / 100 : 0;
  }

  function fit(text, available, minPx, maxPx){
    var per = widthPerPx(text);
    if(!per || !available || available < 0) return 0;
    var size = available / per;
    if(size > maxPx) size = maxPx;
    if(size < minPx) size = minPx;
    return Math.floor(size);
  }

  function apply(){
    var vw = window.innerWidth;
    var mobile = vw <= 820;
    var narrow = vw <= 900;

    /* Collection header: mobile only. */
    var gho = document.querySelector('.collhead .gho3--dev');
    if(gho){
      if(mobile){
        var head = gho.parentElement;
        var size = fit(gho.textContent.trim(), head.clientWidth - 24, 28, 200);
        if(size) gho.style.setProperty('font-size', size + 'px', 'important');
      } else {
        gho.style.removeProperty('font-size');
      }
    }

    /* Handwoven Signatures. */
    var hwrap = document.querySelector('.hws .wrap');
    if(hwrap){
      var hAvail = narrow
        ? hwrap.clientWidth * MOBILE_SHARE
        : hwrap.clientWidth - 20;
      var hSize = fit('\u0939\u0948\u0902\u0921\u092E\u0947\u0921', hAvail, 28, 420);
      if(hSize) hwrap.style.setProperty('--pdev-hws', hSize + 'px');
    }

    /* Gift Concierge. */
    var chead = document.querySelector('.conc-v2 .conc-head');
    if(chead){
      var cAvail = narrow
        ? chead.clientWidth * MOBILE_SHARE
        : chead.clientWidth - 20;
      var cSize = fit('\u0924\u094B\u0939\u092B\u093C\u093E', cAvail, 28, 420);
      if(cSize) chead.style.setProperty('--pdev-conc', cSize + 'px');
    }

    /* Footer. */
    var wm = document.querySelector('.fut .wm3--dev');
    if(wm){
      var fut = wm.parentElement;
      var text = wm.textContent.trim();
      if(mobile){
        var clusters = Math.max(text.replace(/[\u0900-\u0903\u093A-\u094F\u0951-\u0957\u0962\u0963]/g, '').length, 1);
        var vSize = Math.floor((fut.clientHeight * 0.94) / (clusters * 1.06));
        if(vSize > 300) vSize = 300;
        if(vSize < 40) vSize = 40;
        wm.style.setProperty('font-size', vSize + 'px', 'important');
      } else {
        var fSize = fit(text, fut.clientWidth * 0.99, 40, 460);
        if(fSize) wm.style.setProperty('font-size', fSize + 'px', 'important');
      }
    }
  }

  function boot(){
    apply();
    if(document.fonts && document.fonts.ready && document.fonts.ready.then){
      document.fonts.ready.then(apply).catch(function(){});
    }
    setTimeout(apply, 600);
    setTimeout(apply, 1600);
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  window.addEventListener('load', apply);

  var t;
  window.addEventListener('resize', function(){
    clearTimeout(t);
    t = setTimeout(apply, 160);
  });
})();
